<header class="flex w-full items-center justify-between pb-4">
  <ng-content></ng-content>
</header>
